module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_1.d5d7b750.png";